export default __webpack_public_path__ + "static/media/AirplaneReturn.a0bde39c.svg";